export default __webpack_public_path__ + "static/media/233.019f27b0.svg";